import React, { ReactElement } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { TransitionDirection } from 'ggApp/modules/stepper/utils/enums';

import { Container, Content, ANIMATION_DURATION_IN_MS } from './styles';

type AnimatedContainerProps = {
    className?: string;
    transitionDirection: TransitionDirection;
    animationKey: string;
    children: ReactElement;
    classNames?: {
        animatedContainer?: string;
        animatedContent?: string;
    };
};

const AnimatedContainer = ({
    className,
    classNames = {},
    transitionDirection,
    animationKey,
    children,
}: AnimatedContainerProps): JSX.Element => {
    return (
        <TransitionGroup
            component={Container}
            childFactory={(child) =>
                React.cloneElement(child, {
                    transitionDirection,
                })
            }
            className={className ?? classNames.animatedContainer}
        >
            <CSSTransition
                classNames="step-content"
                key={animationKey}
                timeout={ANIMATION_DURATION_IN_MS}
                unmountOnExit
            >
                <Content
                    transitionDirection={transitionDirection}
                    className={classNames.animatedContent}
                >
                    {children}
                </Content>
            </CSSTransition>
        </TransitionGroup>
    );
};

export default AnimatedContainer;
